
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { assetPrefix } from 'constants/app';
import ChartbitWeb from 'features/chartbit/Web';
import PageLoader from 'global/Loading/PageLoader';
import SEO from 'global/SEO';
import useProtectedRoute from 'hooks/useProtectedRoute';
import Head from 'next/head';
import { useRouter } from 'next/router';
import sanitizer from 'string-sanitizer';

function ChartbitPage() {
  const { isLoaded } = useProtectedRoute();
  const router = useRouter();

  const { symbol }: { symbol?: string } = router.query;

  return (
    <>
      <Head>
        <link rel="stylesheet" href={`${assetPrefix}/css/trading.css`} />
      </Head>
      <SEO />
      <PageLoader loaded={isLoaded} />
      <ChartbitWeb symbol={symbol} />
    </>
  );
}

export async function getServerSideProps(context) {
  const { params } = context;
  let { symbol } = params;
  symbol = symbol.replace('-', ' ');
  symbol = sanitizer.sanitize.keepSpace(symbol);
  symbol = symbol.replace(' ', '-');

  return {
    props: {
      symbol,
    },
  };
}

export default ChartbitPage;
